// CMYK color type

import type { ColorComponent } from "../Units"

export type CMYKColor = {
  alpha: ColorComponent
  cyan: ColorComponent
  black: ColorComponent
  magenta: ColorComponent
  yellow: ColorComponent
}
